import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dayjs from 'dayjs';
import { JOVE_PRICE_UNIT_CURRENCY_KEY, JOVE_PRICE_UNIT_PERCENT_KEY } from '../../constants/common';
export var convertServerBrokerDetailDataToLocalStructureData = function convertServerBrokerDetailDataToLocalStructureData(data, configData) {
  var countryList = (configData === null || configData === void 0 ? void 0 : configData.countries) || [];

  var _ref = data || {},
      platform = _ref.platform,
      broker_registration_id = _ref.broker_registration_id,
      name = _ref.name,
      insurance_license_number = _ref.insurance_license_number,
      company_number = _ref.company_number,
      company_office_id = _ref.company_office_id,
      tax_number = _ref.tax_number,
      street_address = _ref.street_address,
      house_number = _ref.house_number,
      flat_number = _ref.flat_number,
      post_code = _ref.post_code,
      city = _ref.city,
      contact_first_name = _ref.contact_first_name,
      contact_last_name = _ref.contact_last_name,
      contact_job_title = _ref.contact_job_title,
      contact_email = _ref.contact_email,
      contact_phone = _ref.contact_phone,
      is_signatory = _ref.is_signatory,
      signatory_first_name = _ref.signatory_first_name,
      signatory_last_name = _ref.signatory_last_name,
      signatory_job_title = _ref.signatory_job_title,
      signatory_email = _ref.signatory_email,
      signatory_phone = _ref.signatory_phone,
      eu_pass_porting = _ref.eu_pass_porting,
      country_code = _ref.country_code,
      allowed_eu_country = _ref.allowed_eu_country,
      documents = _ref.documents,
      invite_message = _ref.invite_message,
      signatory_signature_message = _ref.signatory_signature_message,
      regulated_body_name = _ref.regulated_body_name,
      acturis_activated = _ref.acturis_activated,
      partner_type = _ref.partner_type,
      payload = _ref.payload,
      parent_id = _ref.parent_id;

  var legalEntityCountryItem = countryList === null || countryList === void 0 ? void 0 : countryList.find(function (item) {
    return item.code === country_code;
  });
  var operateCountries = [];
  (allowed_eu_country || []).forEach(function (code) {
    var item = countryList === null || countryList === void 0 ? void 0 : countryList.find(function (item) {
      return item.code === code;
    });

    if (item) {
      operateCountries.push(item);
    }
  });

  var _ref2 = (payload === null || payload === void 0 ? void 0 : payload.product_fee_config) || {},
      broker_commission_fee = _ref2.broker_commission_fee,
      broker_commission_fee_type = _ref2.broker_commission_fee_type,
      broker_fee = _ref2.broker_fee,
      broker_fee_type = _ref2.broker_fee_type,
      underwriting_fee = _ref2.underwriting_fee,
      underwriting_fee_type = _ref2.underwriting_fee_type,
      underwriting_fee_cap = _ref2.underwriting_fee_cap;

  return {
    legalEntityCountry: legalEntityCountryItem || null,
    brokerPlatform: platform || '',
    countryBrokerId: broker_registration_id || '',
    legalEntityName: name || '',
    fcaLicenseNumber: insurance_license_number || '',
    insuranceLicenseNumber: insurance_license_number || '',
    companyNumber: company_number || '',
    companyOfficeId: company_office_id || '',
    taxNumber: tax_number || '',
    streetAddress: street_address || '',
    houseNumber: house_number || '',
    flatNumber: flat_number || '',
    zipCode: post_code || '',
    city: city || '',
    contactFirstName: contact_first_name || '',
    contactLastName: contact_last_name || '',
    contactJobTitle: contact_job_title || '',
    contactEmail: contact_email || '',
    contactPhone: contact_phone || '',
    isTheSigner: !!is_signatory,
    signUserFirstName: signatory_first_name || '',
    signUserLastName: signatory_last_name || '',
    signUserJobTitle: signatory_job_title || '',
    signUserEmail: signatory_email || '',
    signUserPhone: signatory_phone || '',
    signUserInviteMessage: invite_message || '',
    operateCountries: operateCountries,
    confirmPassport: !!eu_pass_porting,
    documentList: documents || [],
    signUserSignature: signatory_signature_message || '',
    regulatedBodyName: regulated_body_name || '',
    acturisActivated: acturis_activated || '',
    brokerCommission: broker_commission_fee || null,
    brokerCommissionUnit: broker_commission_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    brokerFee: broker_fee || null,
    brokerFeeUnit: broker_fee_type || JOVE_PRICE_UNIT_CURRENCY_KEY,
    underwritingFee: underwriting_fee || null,
    underwritingFeeUnit: underwriting_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    underwritingFeeCap: underwriting_fee_cap || null,
    partnerType: partner_type,
    parentLegalEntity: parent_id || '',
    skipSetCommission: !!(payload !== null && payload !== void 0 && payload.skip_set_commission),
    allowDirectPayWithoutRules: !!(payload !== null && payload !== void 0 && payload.allow_direct_pay_without_rules)
  };
};
export var convertServerBrokerActivityRecordWithKeyDataToLocalStructureData = function convertServerBrokerActivityRecordWithKeyDataToLocalStructureData(data) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, convertServerBrokerActivityRecordDemoDataToLocalStructureData(data)), convertServerBrokerActivityRecordOnboardingDataToLocalStructureData(data)), convertServerBrokerActivityRecordOnlineTrainingDataToLocalStructureData(data)), convertServerBrokerActivityRecordInPersonTrainingDataToLocalStructureData(data));
};
export var convertServerBrokerActivityRecordDemoDataToLocalStructureData = function convertServerBrokerActivityRecordDemoDataToLocalStructureData(data) {
  var _data$payload;

  var _ref3 = (data === null || data === void 0 ? void 0 : (_data$payload = data.payload) === null || _data$payload === void 0 ? void 0 : _data$payload.demo) || {},
      demo_booked_date = _ref3.demo_booked_date,
      demo_time = _ref3.demo_time,
      demo_booked_by = _ref3.demo_booked_by,
      broker_demo_responsible_person_user_id = _ref3.broker_demo_responsible_person_user_id,
      demo_status = _ref3.demo_status,
      demo_outcome = _ref3.demo_outcome,
      demo_follow_up_action = _ref3.demo_follow_up_action,
      demo_notes = _ref3.demo_notes,
      demo_attendees = _ref3.demo_attendees;

  return {
    demoBookedDate: demo_booked_date ? dayjs(demo_booked_date) : null,
    demoTime: demo_time ? dayjs(demo_time, 'HH:mm') : null,
    demoBookedBy: demo_booked_by || '',
    brokerDemoResponsiblePerson: !!broker_demo_responsible_person_user_id ? {
      value: broker_demo_responsible_person_user_id,
      label: broker_demo_responsible_person_user_id
    } : null,
    demoStatus: demo_status || '',
    demoOutcome: demo_outcome || '',
    demoFollowUpAction: demo_follow_up_action || '',
    demoNotes: demo_notes || '',
    demoAttendees: demo_attendees || ''
  };
};
export var convertServerBrokerActivityRecordOnboardingDataToLocalStructureData = function convertServerBrokerActivityRecordOnboardingDataToLocalStructureData(data) {
  var _data$payload2;

  var _ref4 = (data === null || data === void 0 ? void 0 : (_data$payload2 = data.payload) === null || _data$payload2 === void 0 ? void 0 : _data$payload2.onboarding_process_workflow) || {},
      origination_manager_user_id = _ref4.origination_manager_user_id,
      activation_manager_user_id = _ref4.activation_manager_user_id,
      miscellaneous_meeting_date = _ref4.miscellaneous_meeting_date,
      miscellaneous_meeting_time = _ref4.miscellaneous_meeting_time,
      miscellaneous_meeting_status = _ref4.miscellaneous_meeting_status,
      miscellaneous_meeting_responsible_person_user_id = _ref4.miscellaneous_meeting_responsible_person_user_id,
      miscellaneous_meeting_notes = _ref4.miscellaneous_meeting_notes,
      agreement_status = _ref4.agreement_status,
      agreement_signed_date = _ref4.agreement_signed_date,
      onboarding_status = _ref4.onboarding_status,
      onboarding_completed_date = _ref4.onboarding_completed_date,
      broker_start_date = _ref4.broker_start_date,
      broker_status = _ref4.broker_status,
      broker_type = _ref4.broker_type,
      portal_access_status = _ref4.portal_access_status,
      portal_access_activated_date = _ref4.portal_access_activated_date,
      number_of_portal_users = _ref4.number_of_portal_users,
      preferred_training_format = _ref4.preferred_training_format,
      training_contact = _ref4.training_contact,
      commission_agreed = _ref4.commission_agreed,
      payment_arrangement = _ref4.payment_arrangement,
      white_labelled_required = _ref4.white_labelled_required,
      broker_notes = _ref4.broker_notes;

  return {
    originationManager: !!origination_manager_user_id ? {
      value: origination_manager_user_id,
      label: origination_manager_user_id
    } : null,
    activationManager: !!activation_manager_user_id ? {
      value: activation_manager_user_id,
      label: activation_manager_user_id
    } : null,
    miscMeetingDate: miscellaneous_meeting_date ? dayjs(miscellaneous_meeting_date) : null,
    miscMeetingTime: miscellaneous_meeting_time ? dayjs(miscellaneous_meeting_time, 'HH:mm') : null,
    miscMeetingStatus: miscellaneous_meeting_status || '',
    miscMeetingResponsiblePerson: !!miscellaneous_meeting_responsible_person_user_id ? {
      value: miscellaneous_meeting_responsible_person_user_id,
      label: miscellaneous_meeting_responsible_person_user_id
    } : null,
    miscMeetingNotes: miscellaneous_meeting_notes || '',
    agreementStatus: agreement_status || '',
    agreementSignedDate: agreement_signed_date ? dayjs(agreement_signed_date) : null,
    onboardingStatus: onboarding_status || '',
    onboardingCompletedDate: onboarding_completed_date ? dayjs(onboarding_completed_date) : null,
    brokerStartDate: broker_start_date ? dayjs(broker_start_date) : null,
    brokerStatus: broker_status || '',
    brokerType: broker_type || '',
    portalAccessStatus: portal_access_status || '',
    portalAccessActivatedDate: portal_access_activated_date ? dayjs(portal_access_activated_date) : null,
    numberOfPortalUsers: number_of_portal_users !== null && number_of_portal_users !== void 0 ? number_of_portal_users : null,
    preferredTrainingFormat: preferred_training_format || '',
    trainingContact: training_contact || '',
    commissionAgreed: commission_agreed !== null && commission_agreed !== void 0 ? commission_agreed : null,
    paymentArrangement: payment_arrangement || '',
    whiteLabelledRequired: white_labelled_required !== null && white_labelled_required !== void 0 ? white_labelled_required : null,
    brokerNotes: broker_notes || ''
  };
};
export var convertServerBrokerActivityRecordOnlineTrainingDataToLocalStructureData = function convertServerBrokerActivityRecordOnlineTrainingDataToLocalStructureData(data) {
  var _data$payload3;

  var _ref5 = (data === null || data === void 0 ? void 0 : (_data$payload3 = data.payload) === null || _data$payload3 === void 0 ? void 0 : _data$payload3.online_training) || {},
      online_training_booked_date = _ref5.online_training_booked_date,
      online_meeting_responsible_person_user_id = _ref5.online_meeting_responsible_person_user_id,
      online_training_date = _ref5.online_training_date,
      online_training_time = _ref5.online_training_time,
      online_training_status = _ref5.online_training_status,
      online_training_outcome = _ref5.online_training_outcome,
      online_training_notes = _ref5.online_training_notes,
      online_training_materials_required = _ref5.online_training_materials_required,
      online_training_materials_sent = _ref5.online_training_materials_sent;

  return {
    onlineTrainingBookedDate: online_training_booked_date ? dayjs(online_training_booked_date) : null,
    onlineMeetingResponsiblePerson: !!online_meeting_responsible_person_user_id ? {
      value: online_meeting_responsible_person_user_id,
      label: online_meeting_responsible_person_user_id
    } : null,
    onlineTrainingDate: online_training_date ? dayjs(online_training_date) : null,
    onlineTrainingTime: online_training_time ? dayjs(online_training_time, 'HH:mm') : null,
    onlineTrainingStatus: online_training_status || '',
    onlineTrainingOutcome: online_training_outcome || '',
    onlineTrainingMaterialsRequired: online_training_materials_required !== null && online_training_materials_required !== void 0 ? online_training_materials_required : null,
    onlineTrainingMaterialsSent: online_training_materials_sent !== null && online_training_materials_sent !== void 0 ? online_training_materials_sent : null,
    onlineTrainingNotes: online_training_notes || ''
  };
};
export var convertServerBrokerActivityRecordInPersonTrainingDataToLocalStructureData = function convertServerBrokerActivityRecordInPersonTrainingDataToLocalStructureData(data) {
  var _data$payload4;

  var _ref6 = (data === null || data === void 0 ? void 0 : (_data$payload4 = data.payload) === null || _data$payload4 === void 0 ? void 0 : _data$payload4.in_person_training) || {},
      in_person_training_responsible_person_user_id = _ref6.in_person_training_responsible_person_user_id,
      in_person_training_booked_date = _ref6.in_person_training_booked_date,
      in_person_training_date = _ref6.in_person_training_date,
      in_person_training_status = _ref6.in_person_training_status,
      in_person_training_outcome = _ref6.in_person_training_outcome,
      in_person_training_notes = _ref6.in_person_training_notes,
      training_material_required = _ref6.training_material_required,
      training_material_sent = _ref6.training_material_sent;

  var _ref7 = (data === null || data === void 0 ? void 0 : data.payload) || {},
      commission_rate_effective_date = _ref7.commission_rate_effective_date,
      apply_commission_from_inception = _ref7.apply_commission_from_inception;

  return {
    inPersonTrainingResponsiblePerson: !!in_person_training_responsible_person_user_id ? {
      value: in_person_training_responsible_person_user_id,
      label: in_person_training_responsible_person_user_id
    } : null,
    inPersonTrainingBookedDate: in_person_training_booked_date ? dayjs(in_person_training_booked_date) : null,
    inPersonTrainingDate: in_person_training_date ? dayjs(in_person_training_date) : null,
    inPersonTrainingStatus: in_person_training_status || '',
    inPersonTrainingOutcome: in_person_training_outcome || '',
    inPersonTrainingMaterialsRequired: training_material_required !== null && training_material_required !== void 0 ? training_material_required : null,
    inPersonTrainingMaterialsSent: training_material_sent !== null && training_material_sent !== void 0 ? training_material_sent : null,
    inPersonTrainingNotes: in_person_training_notes || '',
    commissionRateEffectiveDate: commission_rate_effective_date || null,
    applyCommissionFromInception: !!apply_commission_from_inception
  };
};